import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { DataHelper } from '@app/helpers/data.helper';
import { environment } from '@environments/environment';

export interface ILimitTimeModel {
  timeName: string;
  timeId: number;
  timeValue: number;
}

@Component({
  selector: 'self-limits-component',
  templateUrl: '../sharedTemplates/self-limits.component.html',
})
export class SelfLimits implements OnInit {
  //bet3000

  //   Limit Setlemelerinde input değerleri görünmesin ,standartlimit yazısı görülsün istendiği için manuel limit setlemeleri yapıldı.
  // 1103.03 gibi değerler DB tarafından getLocaleExtraDayPeriodRules.Değiştirilmemeli.İnput valuelerine null değeri atanması placeholder ın çalışması için.
  LOSS_DAILY_STANDARD_LIMIT = 200000;
  STAKE_DAILY_STANDARD_LIMIT = 1000000;
  DEPOSIT_DAILY_STANDARD_LIMIT = 30000;
  LOSS_WEEKLY_STANDARD_LIMIT = 200000;
  STAKE_WEEKLY_STANDARD_LIMIT = 1000000;
  DEPOSIT_WEEKLY_STANDARD_LIMIT = 30000;
  LOSS_MONTHLY_STANDARD_LIMIT = 200000;
  STAKE_MONTHLY_STANDARD_LIMIT = 1000000;
  DEPOSIT_MONTHLY_STANDARD_LIMIT = 30000;

  scufaG_FinApi_Limit_Obj = {
    lugas_Min_Lim: 1,
    Lugas_Max_Lim: 1000,
    scufaG_Min_Lim: 1001,
    scufaG_Max_Lim: 10000,
    FinApi_Min_Lim: 10001,
    FinApi_Max_Lim: 30000,
  };

  lossLimitDropDownIsOpen = false;
  wageringLimitDropDownIsOpen = false;
  depositLimitDropDownIsOpen = false;
  sessionLimitDropDownIsOpen = false;
  sessionTimerDropDownIsOpen = false;
  selfExclusionDropDownIsOpen = false;
  accountClosureDropDownIsOpen = false;
  isOpenDetailLimit = false;
  montlyLimitDropDownIsOpen = false;
  errorMessage: any;
  translator = new TranslatePipe(this._LocalizationService);
  sessionTimerCombo = [
    { id: 0, name: this.translator.transform('b3000_off', null) },
    { id: 1, name: `1 ${this.translator.transform('b3000_hour', null)}` },
    { id: 2, name: `2 ${this.translator.transform('b3000_hours', null)}` },
    { id: 3, name: `3 ${this.translator.transform('b3000_hours', null)}` },
    { id: 4, name: `4 ${this.translator.transform('b3000_hours', null)}` },
    { id: 5, name: `5 ${this.translator.transform('b3000_hours', null)}` },
    { id: 6, name: `6 ${this.translator.transform('b3000_hours', null)}` },
    { id: 7, name: `7 ${this.translator.transform('b3000_hours', null)}` },
    { id: 8, name: `8 ${this.translator.transform('b3000_hours', null)}` },
  ];
  passwordForClosure: '';

  //bet3000

  selfLimit: any;
  password: any;
  stakeDailyLimitModel: number;
  stakeWeeklyLimitModel: number;
  stakeMontlyLimitModel: number;
  DepositDailyLimitModel: number;
  DepositWeeklyLimitModel: number;
  DepositMonthlyLimitModel: number;
  LossDailyLimitModel: number;
  LossWeeklyLimitModel: number;
  LossMonthlyLimitModel: number;
  stakeDailyLimitModelConsumed: number;
  stakeWeeklyLimitModelConsumed: number;
  stakeMontlyLimitModelConsumed: number;
  DepositDailyLimitModelConsumed: number;
  DepositWeeklyLimitModelConsumed: number;
  DepositMonthlyLimitModelConsumed: number;
  LossDailyLimitModelConsumed: number;
  LossWeeklyLimitModelConsumed: number;
  LossMonthlyLimitModelConsumed: number;
  formattedDate: any;
  activityDate: any;
  isSupInfoShow = false;

  days = 7; // For Plus activate Days
  oldSelfLimitData: any;
  now = new Date();
  today = new Date();
  nowShortFormat: any;

  todayShortFormat: string;
  selectedTime: ILimitTimeModel = {
    timeName: 'Day',
    timeId: 1,
    timeValue: 1,
  };
  timeList: Array<ILimitTimeModel> = [
    {
      timeName: 'Day',
      timeId: 1,
      timeValue: 1,
    },

    {
      timeName: 'Week',
      timeId: 2,
      timeValue: 2,
    },
    {
      timeName: 'Month',
      timeId: 3,
      timeValue: 3,
    },
  ];
  timeList2: Array<ILimitTimeModel> = [
    {
      timeName: 'Day',
      timeId: 1,
      timeValue: 4,
    },

    {
      timeName: 'Week',
      timeId: 2,
      timeValue: 5,
    },
  ];
  limitType = '';

  stakeModel: number;
  lostModel: number;
  depositModel: number;
  depositMontlyModel: any;
  schufa_Fin_Error = false;
  errorMessageState = '';
  limitDateObj = {
    DepositActivityDate: new Date(),
    DepositDailyDate: new Date(),
    DepositMounthlyDate: new Date(),
    DepositWeeklyDate: new Date(),
    LossDailyDate: new Date(),
    LossWeeklyDate: new Date(),
    LossMounthlyDate: new Date(),
    StakeDailyDate: new Date(),
    StakeWeeklyDate: new Date(),
    StakeMonthlyDate: new Date(),

    DepositDailyActivityDate: new Date(),
    DepositWeeklyActivityDate: new Date(),

    LossDailyActivityDate: new Date(),
    LossWeeklyActivityDate: new Date(),
    LossMounthlyActivityDate: new Date(),
    StakeDailyActivityDate: new Date(),
    StakeWeeklyActivityDate: new Date(),
    StakeMonthlyActivityDate: new Date(),

    IsFirstSet: false,
  };
  process(e): string {
    return `${e} k`;
  }

  // SLIDER
  disabledButtonMD: any;

  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper
  ) {}

  ngOnInit() {
    this.addDays();
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Self_Limits');
    this.getSelfLimits();
  }

  getSelfLimits() {
    this._ApiService.getSelfLimits().then(x => {
      if (x && x.length > 0) {
        this.selfLimit = x[0];
        this.stakeDailyLimitModel = this.selfLimit.StakeDailyLimit;
        this.stakeWeeklyLimitModel = this.selfLimit.StakeWeeklyLimit;
        this.stakeMontlyLimitModel = this.selfLimit.StakeMonthlyLimit;
        this.DepositDailyLimitModel = this.selfLimit.DepositDailyLimit;
        this.DepositWeeklyLimitModel = this.selfLimit.DepositWeeklyLimit;
        this.DepositMonthlyLimitModel = this.selfLimit.DepositMonthlyLimit;
        this.LossDailyLimitModel = this.selfLimit.LossDailyLimit;
        this.LossWeeklyLimitModel = this.selfLimit.LossWeeklyLimit;
        this.LossMonthlyLimitModel = this.selfLimit.LossMonthlyLimit;
        this.oldSelfLimitData = this.selfLimit;

        //Consumed Setting
        this.stakeDailyLimitModelConsumed = this.selfLimit.StakeDailyLimitConsumed;
        this.stakeWeeklyLimitModelConsumed = this.selfLimit.StakeWeeklyLimitConsumed;
        this.stakeMontlyLimitModelConsumed = this.selfLimit.StakeMonthlyLimitConsumed;
        this.DepositDailyLimitModelConsumed = this.selfLimit.DepositDailyLimitConsumed;
        this.DepositWeeklyLimitModelConsumed = this.selfLimit.DepositWeeklyLimitConsumed;
        this.DepositMonthlyLimitModelConsumed = this.selfLimit.DepositMonthlyLimitConsumed;
        this.LossDailyLimitModelConsumed = this.selfLimit.LossDailyLimitConsumed;
        this.LossWeeklyLimitModelConsumed = this.selfLimit.LossWeeklyLimitConsumed;
        this.LossMonthlyLimitModelConsumed = this.selfLimit.LossMonthlyLimitConsumed;

        if (this.selfLimit.DepositMonthlyLimit === 99999) {
          this.depositMontlyModel = '';
        } else {
          this.depositMontlyModel = this.selfLimit.DepositMonthlyLimit;
        }

        this.limitDateObj.DepositActivityDate = new Date(this.selfLimit.DepositActivityDate);
        this.limitDateObj.DepositDailyDate = new Date(this.selfLimit.DepositDailyDate);
        this.limitDateObj.DepositWeeklyDate = new Date(this.selfLimit.DepositWeeklyDate);
        this.limitDateObj.DepositMounthlyDate = new Date(this.selfLimit.DepositMounthlyDate);

        this.limitDateObj.LossDailyDate = new Date(this.selfLimit.LossDailyDate);
        this.limitDateObj.LossWeeklyDate = new Date(this.selfLimit.LossWeeklyDate);
        this.limitDateObj.LossMounthlyDate = new Date(this.selfLimit.LossMounthlyDate);

        this.limitDateObj.StakeDailyDate = new Date(this.selfLimit.StakeDailyDate);
        this.limitDateObj.StakeWeeklyDate = new Date(this.selfLimit.StakeWeeklyDate);
        this.limitDateObj.StakeMonthlyDate = new Date(this.selfLimit.StakeMonthlyDate);

        this.limitDateObj.DepositDailyActivityDate = new Date(this.selfLimit.DepositDailyActivityDate);
        this.limitDateObj.DepositWeeklyActivityDate = new Date(this.selfLimit.DepositWeeklyActivityDate);

        this.limitDateObj.LossDailyActivityDate = new Date(this.selfLimit.LossDailyActivityDate);
        this.limitDateObj.LossWeeklyActivityDate = new Date(this.selfLimit.LossWeeklyActivityDate);
        this.limitDateObj.LossMounthlyActivityDate = new Date(this.selfLimit.LossMounthlyActivityDate);

        this.limitDateObj.StakeDailyActivityDate = new Date(this.selfLimit.StakeDailyActivityDate);
        this.limitDateObj.StakeWeeklyActivityDate = new Date(this.selfLimit.StakeWeeklyActivityDate);
        this.limitDateObj.StakeMonthlyActivityDate = new Date(this.selfLimit.StakeMonthlyActivityDate);
        this.limitDateObj.IsFirstSet = this.selfLimit.IsFirstSet;

        this.formattedDate = new Date(this.selfLimit.UpdateDate);
        this.activityDate = new Date(this.selfLimit.ActivityDate);
      }
    });
  }

  addDays() {
    this.now.setDate(this.now.getDate() + this.days);

    this.nowShortFormat = this.now.toLocaleDateString();

    this.today.setDate(this.today.getDate() + 0);

    this.todayShortFormat = this.today.toLocaleDateString();
  }
  saveSelfLimitsData() {
    this.selfLimit.StakeDailyLimit = this.stakeDailyLimitModel;
    this.selfLimit.StakeWeeklyLimit = this.stakeWeeklyLimitModel;
    this.selfLimit.StakeMonthlyLimit = this.stakeMontlyLimitModel;
    this.selfLimit.DepositDailyLimit = this.DepositDailyLimitModel;
    this.selfLimit.DepositWeeklyLimit = this.DepositWeeklyLimitModel;
    this.selfLimit.DepositMonthlyLimit = this.DepositMonthlyLimitModel;
    this.selfLimit.LossDailyLimit = this.LossDailyLimitModel;
    this.selfLimit.LossWeeklyLimit = this.LossWeeklyLimitModel;
    this.selfLimit.LossMonthlyLimit = this.LossMonthlyLimitModel;

    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.saveSelfLimits(this.selfLimit).then(result => {
      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.successSnackBar(t_message, '');
          this.getSelfLimits();
        }
      }
    });
  }

  toggleDropDown(item) {
    if (item === 0) {
      this.montlyLimitDropDownIsOpen = !this.montlyLimitDropDownIsOpen;
    } else if (item == 1) {
      this.lossLimitDropDownIsOpen = !this.lossLimitDropDownIsOpen;
      this.selectedTime = {
        timeName: 'Day',
        timeId: 1,
        timeValue: 1,
      };
      this.limitType = '';
      this.depositLimitDropDownIsOpen = false;
    } else if (item == 2) {
      this.wageringLimitDropDownIsOpen = !this.wageringLimitDropDownIsOpen;
    } else if (item == 3) {
      this.depositLimitDropDownIsOpen = !this.depositLimitDropDownIsOpen;
      this.selectedTime = {
        timeName: 'Day',
        timeId: 1,
        timeValue: 4,
      };
      this.lossLimitDropDownIsOpen = false;
    } else if (item == 4) {
      this.sessionLimitDropDownIsOpen = !this.sessionLimitDropDownIsOpen;
    } else if (item == 5) {
      this.sessionTimerDropDownIsOpen = !this.sessionTimerDropDownIsOpen;
    } else if (item == 6) {
      this.selfExclusionDropDownIsOpen = !this.selfExclusionDropDownIsOpen;
    } else if (item == 7) {
      this.accountClosureDropDownIsOpen = !this.accountClosureDropDownIsOpen;
    }
  }

  checkPassword() {
    const translator = new TranslatePipe(this._LocalizationService);

    this._ApiService.checkPassword(this.passwordForClosure).then(result => {
      if (result && result.length > 0) {
        if (result[0].resultcode == 0) {
          this._UiHelper.errorSnackBar(result[0].resultmessage, '');

          return 'error|System Error';
        } else {
          if (result[0].resultcode === 1) {
            this.submitAccountLockDatas();
          }
        }
      }
    });
  }

  submitAccountLockDatas() {
    const translator = new TranslatePipe(this._LocalizationService);
    const lockDayValue = 98;
    const LockReasonValue = 78;

    this._ApiService.getProcCustomerAccountLockNewResult(lockDayValue, LockReasonValue).then(result => {
      if (result.resultcode == '') {
        return 'error|System Error';
      } else {
        if (result.resultcode == '') {
          this._UiHelper.errorSnackBar(result.resultmessage, '');
        } else if (result.resultcode == 'errorcode') {
          const t_message = translator.transform(result.resultmessage, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.resultcode == '117') {
          this._UiHelper.successSnackBar(result.resultmessage, '');
        }
      }
    });
  }

  openDetailLimit() {
    this.isOpenDetailLimit = true;
  }
  timeBoxClick(selectTime) {
    this.selectedTime = selectTime;
  }
  changeLimitTab(limitType: string) {
    if (limitType === 'cancel') {
      this.errorMessageState = '';
      this.schufa_Fin_Error = false;
      this.limitType = '';
    } else {
      if (this.selectedTime.timeName === 'Day') {
        if (this.LossDailyLimitModel === this.LOSS_DAILY_STANDARD_LIMIT) {
          this.lostModel = null;
        } else {
          this.lostModel = this.LossDailyLimitModel;
        }
        if (this.stakeDailyLimitModel === this.STAKE_DAILY_STANDARD_LIMIT) {
          this.stakeModel = null;
        } else {
          this.stakeModel = this.stakeDailyLimitModel;
        }
        if (this.DepositDailyLimitModel === this.DEPOSIT_DAILY_STANDARD_LIMIT) {
          this.depositModel = null;
        } else {
          this.depositModel = this.DepositDailyLimitModel;
        }
      } else if (this.selectedTime.timeName === 'Week') {
        if (this.LossWeeklyLimitModel === this.LOSS_WEEKLY_STANDARD_LIMIT) {
          this.lostModel = null;
        } else {
          this.lostModel = this.LossWeeklyLimitModel;
        }
        if (this.stakeWeeklyLimitModel === this.STAKE_WEEKLY_STANDARD_LIMIT) {
          this.stakeModel = null;
        } else {
          this.stakeModel = this.stakeWeeklyLimitModel;
        }
        if (this.DepositWeeklyLimitModel === this.DEPOSIT_WEEKLY_STANDARD_LIMIT) {
          this.depositModel = null;
        } else {
          this.depositModel = this.DepositWeeklyLimitModel;
        }
      } else if (this.selectedTime.timeName === 'Month') {
        if (this.LossMonthlyLimitModel === this.LOSS_MONTHLY_STANDARD_LIMIT) {
          this.lostModel = null;
        } else {
          this.lostModel = this.LossMonthlyLimitModel;
        }

        if (this.stakeMontlyLimitModel === this.STAKE_MONTHLY_STANDARD_LIMIT) {
          this.stakeModel = null;
        } else {
          this.stakeModel = this.stakeMontlyLimitModel;
        }

        this.depositMontlyModel = this.DepositMonthlyLimitModel;
      }
      this.limitType = limitType;
    }
    this._ApiService.getWalletList().then(result => {
      this._UserHelper.setWalletList(result);
    });
  }
  changeLostLimit(event) {
    if (event === '') {
      this.stakeModel = 0;
      this.lostModel = 0;
    } else {
      this.lostModel = (this.stakeModel * 20) / 100;
    }
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  saveSelfLimitsData2(limitType: number) {
    //Parametrik olarak alınan limitType 3 aylık deposit ,1 stake ve lost, 2 diğer günlük ve haftalık
    //Lost Limit ve Stake Limit beraber Setleneceği için 2 ApiCall yapılacak
    //DB tarafında TimeType Karşılığı Day--> 1, Week--> 2 ,Month--> 3
    //DB tarafında LimitType Karşılığı Stake--> 1, Deposit --> 2 ,Loss--> 3
    this.schufa_Fin_Error = false;
    this.errorMessageState = '';

    if (limitType === 1) {
      const translator = new TranslatePipe(this._LocalizationService);

      this._ApiService.saveSelfLimits2(this.stakeModel, limitType, this.selectedTime.timeId).then(result => {
        if (result.code == '') {
          return 'error|System Error';
        } else {
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            const t_message = translator.transform(result.message, null);

            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            this._ApiService.saveSelfLimits2(this.lostModel, 3, this.selectedTime.timeId).then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = translator.transform(result.message, null);

                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  const t_message = translator.transform(result.message, null);
                  this._UiHelper.successSnackBar(t_message, '');
                  this.limitType = '';

                  this.getSelfLimits();
                }
              }
            });
          }
        }
      });
    } else if (limitType === 2) {
      if (this.depositModel > this.DEPOSIT_DAILY_STANDARD_LIMIT) {
        this.depositModel = this.DEPOSIT_DAILY_STANDARD_LIMIT;
      }
      const translator = new TranslatePipe(this._LocalizationService);
      this._ApiService.saveSelfLimits2(this.depositModel, limitType, this.selectedTime.timeId).then(result => {
        if (result.code == '') {
          return 'error|System Error';
        } else {
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            const t_message = translator.transform(result.message, null);

            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.successSnackBar(t_message, '');
            this.limitType = '';

            this.getSelfLimits();
          }
        }
      });
    } else if (limitType === 3) {
      const translator = new TranslatePipe(this._LocalizationService);
      if (this.depositMontlyModel * 1 > this.DEPOSIT_MONTHLY_STANDARD_LIMIT) {
        this.schufa_Fin_Error = true;
        this.errorMessageState = 'above30000';
      } else if (
        this.scufaG_FinApi_Limit_Obj.scufaG_Min_Lim <= this.depositMontlyModel * 1 &&
        this.depositMontlyModel * 1 <= this.scufaG_FinApi_Limit_Obj.scufaG_Max_Lim &&
        this._DataHelper.selectedWallet.IsShufa
      ) {
        this._ApiService.saveSelfLimits2(this.depositMontlyModel, 2, 3).then(result => {
          if (result.code == '') {
            return 'error|System Error';
          } else {
            if (result.code == 'error') {
              this._UiHelper.errorSnackBar(result.message, '');
            } else if (result.code == 'errorcode') {
              const t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(t_message, '');
            } else if (result.code == 'success') {
              const t_message = translator.transform(result.message, null);
              this._UiHelper.successSnackBar(t_message, '');
              this.limitType = '';

              this.getSelfLimits();
            }
          }
        });
      } else if (
        this.scufaG_FinApi_Limit_Obj.FinApi_Min_Lim <= this.depositMontlyModel * 1 &&
        this.depositMontlyModel * 1 <= this.scufaG_FinApi_Limit_Obj.FinApi_Max_Lim &&
        this._DataHelper.selectedWallet.IsFin
      ) {
        this._ApiService.saveSelfLimits2(this.depositMontlyModel, 2, 3).then(result => {
          if (result.code == '') {
            return 'error|System Error';
          } else {
            if (result.code == 'error') {
              this._UiHelper.errorSnackBar(result.message, '');
            } else if (result.code == 'errorcode') {
              const t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(t_message, '');
            } else if (result.code == 'success') {
              const t_message = translator.transform(result.message, null);
              this._UiHelper.successSnackBar(t_message, '');
              this.limitType = '';

              this.getSelfLimits();
            }
          }
        });
      } else if (this.scufaG_FinApi_Limit_Obj.lugas_Min_Lim <= this.depositMontlyModel * 1 && this.depositMontlyModel * 1 <= this.scufaG_FinApi_Limit_Obj.Lugas_Max_Lim) {
        this._ApiService.saveSelfLimits2(this.depositMontlyModel, 2, 3).then(result => {
          if (result.code == '') {
            return 'error|System Error';
          } else {
            if (result.code == 'error') {
              if (result.message === 'The player has not been registered yet., ') {
                const translator = new TranslatePipe(this._LocalizationService);
                const t_message2 = translator.transform('errorcodeRegister2', null);
                const navigateLink = environment.contactUrl;

                this._UiHelper.errorSnackBarWithAction(result.message, t_message2, navigateLink);
              } else {
                this._UiHelper.errorSnackBar(result.message, '');
              }
            } else if (result.code == 'errorcode') {
              if (result.message === 'The player has not been registered yet., ') {
                const translator = new TranslatePipe(this._LocalizationService);
                const t_message2 = translator.transform('errorcodeRegister2', null);
                const navigateLink = environment.contactUrl;

                this._UiHelper.errorSnackBarWithAction(result.message, t_message2, navigateLink);
              } else {
                const t_message = translator.transform(result.message, null);

                this._UiHelper.errorSnackBar(t_message, '');
              }
            } else if (result.code == 'success') {
              const t_message = translator.transform(result.message, null);
              this._UiHelper.successSnackBar(t_message, '');
              this.limitType = '';

              this.getSelfLimits();
            }
          }
        });
      } else {
        this.schufa_Fin_Error = true;
        if (this.scufaG_FinApi_Limit_Obj.scufaG_Min_Lim <= this.depositMontlyModel * 1 && this.depositMontlyModel * 1 <= this.scufaG_FinApi_Limit_Obj.scufaG_Max_Lim) {
          this.errorMessageState = 'above1000';
        } else if (this.scufaG_FinApi_Limit_Obj.FinApi_Min_Lim <= this.depositMontlyModel * 1 && this.depositMontlyModel * 1 <= this.scufaG_FinApi_Limit_Obj.FinApi_Max_Lim) {
          this.errorMessageState = 'above10000';
        }
      }
    }
  }

  goToVerificationSow() {
    this._UiHelper.openVerificationSow();
    this._UiHelper.b3000SetRightMenuState('close');
  }
}
